<template>
  <div class="px-3 mb-3 border border-primary">
      <div class="row" style="background-color:#e5e5e5">
          <div class="col col-md-6">
              <h5 class="m-2">{{userPlan.type.toUpperCase()}}</h5>
          </div>
          <div class="col col-md-6 px-0">
              <router-link :to="{ name: 'Pricing'}" class="btn btn-outline-primary w-100">Upgrade</router-link>
          </div>
      </div>
      <div class="row p-3">
          <div class="col-xs-12 col-md-4">
            <p>Messages: {{userPlan.messageLeft}}</p>
          </div>
          <div class="col-xs-12 col-md-4">
            <p>Start Date: {{startDate}}</p>
          </div>
          <div class="col-xs-12 col-md-4">
              <p>End Date: {{endDate}}</p>
          </div>
      </div> 
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";

export default {
    name: 'Plan',
    data: function(){
        return{
            user: this.$store.state.user,
            userPlan: {type: '...', messageLeft: '...', startDate: '...'},
            BCuser: null,
            startDate: null,
            endDate: null
        }
    },
    methods:{
        getBCUser: function(user){
            ApiService.getUser(user)
            .then(function (bcuser) {
                this.BCuser = bcuser;
                this.userPlan = bcuser.userPlan;
                this.adjustDates()
            }.bind(this))
            .catch(function (response) {
                this.$dialog.alert(response.description);
            }.bind(this));
        },
        adjustDates: function() {
            var d = null
            if(this.userPlan == undefined){
                //remove later
                this.userPlan = {type: 'free', messageLeft: 100, startDate: Date.now()}
            }
            d = new Date(this.BCuser.userPlan.startDate * 1000);
            this.startDate = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()
            d = new Date(this.BCuser.userPlan.startDate * 1000 + (30*24*60*60*1000));
            this.endDate = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear()
        
        }
    },
    mounted(){
        this.getBCUser(this.user)
    }

}
</script>

